import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@salesforce/design-system-react';

import './SetupStep.scss';

export class SetupStep extends Component {
  renderProgressIndicator() {
    const { step, complete } = this.props;
    return complete ? (
      <div className="step-ring complete">
        <span>
          <Icon category="utility" name="check" size="x-small" inverse />
        </span>
      </div>
    ) : (
      <div className="step-ring">
        <span>{step}</span>
      </div>
    );
  }

  render() {
    const {
      title,
      description,
      rightNav,
      warning,
      hideProgress,
      children
    } = this.props;

    return (
      <div className="setup-step">
        <div className="slds-grid">
          {!hideProgress ? (
            <div className="progress-indicator slds-col">
              {this.renderProgressIndicator()}
            </div>
          ) : null}
          <div className="step-info slds-col">
            <h2 className="slds-m-bottom_x-small">{title}</h2>
            <div className="setup-step-description">{description}</div>
            {warning ? (
              <div className="warning-box">
                <div className="icon-container">
                  <Icon
                    category="utility"
                    name="warning"
                    size="x-small"
                    colorVariant="warning"
                  />
                </div>
                <div className="content-container">{warning}</div>
              </div>
            ) : null}
          </div>
          <div className="right-nav slds-col">{rightNav}</div>
        </div>
        <div className="slds-grid setup-step-children">{children}</div>
      </div>
    );
  }
}

SetupStep.propTypes = {
  step: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  rightNav: PropTypes.node,
  hideProgress: PropTypes.bool,
  complete: PropTypes.bool.isRequired,
  warning: PropTypes.node
};

export default SetupStep;
